export const isIterable = <T>(value: T): value is Extract<T, Iterable<any>> => {
  return typeof value === 'object' && value !== null && Symbol.iterator in value
}
